module.exports = __webpack_public_path__ + "static/media/Juhi Barai.1e43e45d.png";